import { createSlice } from '@reduxjs/toolkit';
import { callerCreator } from '../callerCreator';

const initialState = {
  loading: true,
  error: null,
  reports: null,
};

export const reportsSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    reportPending: (state) => {
      state.loading = true;
      state.error = null;
    },
    reportSuccess: (state, { payload }) => {
      state.loading = false;
      state.reports = payload;
    },
    reportRejected: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

  },
});

export default callerCreator(reportsSlice.actions);
